export enum EXTRACT_DOCUMENT_TYPES {
  ACHIEVEMENT_CERTIFICATE = 'ACHIEVEMENT_CERTIFICATE',
  ACTIVITY_REPORT = 'ACTIVITY_REPORT',
  COMPLETION_DETAILS = 'COMPLETION_DETAILS',
  COMPLETION_TRANSCRIPT = 'COMPLETION_TRANSCRIPT',
  LIST_COMPLETION_DETAILS = 'LIST_COMPLETION_DETAILS',
}
